import { DashboardAdministradorComponent } from '../../pages/dashboard_administrador/dashboard_administrador.component';
import { DashboardAdministrativoComponent } from '../../pages/dashboard_administrativo/dashboard_administrativo.component';
import { DashboardVentasComponent } from '../../pages/dashboard_ventas/dashboard_ventas.component';
export const Constantes = {
    TIPO_AUTENTICACION(): string {
        return 'Bearer';
    },
    GRANT_TYPE(): string {
        return 'client_credentials';
    },
    CONFIGURACION_INICIAL(): string {
        return './assets/configuracioninicial.txt';
    },
    CONFIGURACION_VERSION(): string {
        return './assets/versionactualizacion.txt';
    },
    TOKEN_SOLICITAR(): string {
        return 'connect/token';
    },
    USUARIO_VERIFICAR(): string {
        return 'api/v1/AccesoUsuario/Verificar';
    },
    USUARIO_REFRESCAR(): string {
        return 'api/v1/AccesoUsuario/RecargarToken';
    },
    USUARIO_MENUSEDE(): string {
        return 'api/v1/MenuUsuario/Sede';
    },
    USUARIO_SESION(): string {
        return 'api/v1/SesionUsuario/Registrar';
    },
    CONFIGURACION_LISTAS(): string {
        return 'api/v1/Configuracion/Listas';
    },
    PRODUCTOS_CONSULTAR(): string {
        return 'api/v1/Productos/Consultar';
    },
    PRODUCTOS_CONSULTARVENTAS(): string {
        return 'api/v1/Productos/ConsultarVentas';
    },
    PRODUCTOSRESUMEN_CONSULTAR(): string {
        return 'api/v1/Productos/ConsultarResumen/';
    },
    PRODUCTOSRESUMENUSUARIOMES_CONSULTAR(): string {
        return 'api/v1/Productos/ConsultarResumenMesUsuario/';
    },
    PRODUCTOS_DATOSNOTIFICACION_REGISTRO(): string {
        return 'api/v1/Productos/ConsultarDatosNotificacionRegistro';
    },
    PRODUCTOS_DATOSNOTIFICACION_CAMBIOESTADO(): string {
        return 'api/v1/Productos/ConsultarDatosNotificacionCambioEstado';
    },
    ASESORESRESUMEN_CONSULTAR(): string {
        return 'api/v1/Productos/ConsultarResumenTopAsesores/';
    },
    TOPPRODUCTOSRESUMEN_CONSULTAR(): string {
        return 'api/v1/Productos/ConsultarResumenTopProductos/';
    },
    TOPAFILIADOSRESUMEN_CONSULTAR(): string {
        return 'api/v1/Productos/ConsultarResumenTopAfiliados/';
    },
    TOPCIUDADESRESUMEN_CONSULTAR(): string {
        return 'api/v1/Productos/ConsultarResumenTopCiudades/';
    },
    TOPNUEVOSINACTIVOSAFILIADOSRESUMEN_CONSULTAR(): string {
        return 'api/v1/Productos/ConsultarResumenTopNuevosInactivosAfiliados/';
    },
    TOPAFILIADOSPORTAFOLIORESUMEN_CONSULTAR(): string {
        return 'api/v1/Productos/ConsultarResumenTopPortafolioAfiliados/';
    },
    PRODUCTOS_AFILIAR(): string {
        return 'api/v1/Productos/Afiliar';
    },
    PRODUCTOS_AFILIARARCHIVO(): string {
        return 'api/v1/Productos/AfiliarArchivo';
    },
    PRODUCTOS_NOTIFICARAFILIAR(): string {
        return 'api/v1/Productos/NotificarAfiliacion';
    },
    PRODUCTOS_CONSULTARDATOSADICIONALES(): string {
        return 'api/v1/Productos/ConsultarDatosAdicionalesAliado';
    },
    ROLAPLICACION_ADMINISTRADOR(): string {
        return 'ADMINISTRADOR';
    },
    ROLAPLICACION_ADMINISTRATIVO(): string {
        return 'ADMINISTRATIVO';
    },
    ROLAPLICACION_USUARIOSEDE(): string {
        return 'USUARIOSEDE';
    },
    LISTAS_PROVINCIAS(): string {
        return 'PROVINCIAS';
    },
    LISTAS_CIUDADES(): string {
        return 'CIUDADES';
    },LISTAS_PARAMETROS(): string {
        return 'PARAMETROS';
    },
    LISTAS_GENEROS(): string {
        return 'GENEROS';
    },
    LISTAS_TIPOSIDENTIFICACION(): string {
        return 'TIPOSIDENTIFICACION';
    },
    LISTAS_PRODUCTOSCAMPOS(): string {
        return 'PRODUCTOSCAMPOS';
    },
    LISTAS_PRODUCTOSBENEFICIARIOSCAMPOS(): string {
        return 'PRODUCTOSBENEFICIARIOSCAMPOS';
    },
    LISTAS_OCULTARBENEFICIARIOS(): string {
        return 'PRODUCTOSOCULTARBENEFICIARIOS';
    },
    LISTAS_PRODUCTOSBENEFICIARIOSREQUERIDOS(): string {
        return 'PRODUCTOSBENEFICIARIOSREQUERIDOS';
    },
    LISTAS_PERIODOSPAGO(): string {
        return 'PERIODOSPAGO';
    },
    LISTAS_EDADESNACIMIENTO(): string {
        return 'PRODUCTOS_EDADMINIMAMAXIMA';
    },
    LISTAS_PRODUCTOS_TOMADOR(): string {
        return 'PRODUCTOS_TOMADOR';
    },
    LISTAS_PRODUCTOSPARENTESCOS(): string {
        return 'PRODUCTOSPARENTESCOS';
    },
    LISTAS_PRODUCTOSTIPORIESGO(): string {
        return 'PRODUCTOSTIPORIESGO';
    },
    LISTAS_PRODUCTOS_ANNOS_MODELO(): string {
        return 'PRODUCTOSANNOSMODELO';
    },
    LISTAS_TIPOSBENEFICIARIO(): string {
        return 'TIPOSBENEFICIARIO';
    },
    LISTAS_TIPOASEGURADO(): string {
        return 'TIPOASEGURADO';
    },
    LISTAS_PRODUCTOSTIPOPLAN(): string {
        return 'PRODUCTOSTIPOPLAN';
    },
    LISTAS_PRODUCTOSPLANES(): string {
        return 'PRODUCTOSPLANES';
    },
    LISTAS_COMERCIALIZACION(): string {
        return 'COMERCIALIZACION';
    },
    LISTAS_TIPOAFILIACION(): string {
        return 'TIPOAFILIACION';
    },
    LISTAS_MARCAS(): string {
        return 'MARCAS';
    },
    LISTAS_MARCASREFERENCIAS(): string {
        return 'MARCAS_REFERENCIAS';
    },
    AFILIACION_CONSULTAR(): string {
        return 'api/v1/Productos/ConsultarAfiliado/';
    },
    GESTIONAFILIADOS_CONSULTAR(): string {
        return 'api/v1/GestionAfiliado/Consultar/';
    },
    GESTIONAFILIADOS_CONSULTARDETALLE(): string {
        return 'api/v1/GestionAfiliado/ConsultarDetalle/';
    },
    GESTIONAFILIADOS_CONSULTARDATOSADICIONALES(): string {
        return 'api/v1/GestionAfiliado/ConsultarDatosAdicionales/';
    },
    GESTIONAFILIADOS_CONSULTARMOVIMIENTOS(): string {
        return 'api/v1/GestionAfiliado/ConsultarMovimientos/';
    },
    GESTIONAFILIADOS_CONSULTARBENEFICIARIOS(): string {
        return 'api/v1/GestionAfiliado/ConsultarBeneficiarios/';
    },
    GESTIONAFILIADOS_CONSULTAR_CARTERA(): string {
        return 'api/v1/GestionAfiliado/ConsultarCartera/';
    },
    GESTIONAFILIADOS_CONSULTAR_LISTAS_CONFIGURACION(): string {
        return 'api/v1/GestionAfiliado/ConsultarListasAliado/';
    },
    GESTIONAFILIADOS_ACTUALIZAR_ESTADO(): string {
        return 'api/v1/GestionAfiliado/ActualizarEstado/';
    },
    GESTIONAFILIADOS_NOTIFICARAFILIAR(): string {
        return 'api/v1/GestionAfiliado/NotificarAfiliacion';
    },
    GESTIONAFILIADOS_CONSULTAR_PRODUCTO_CONFIGURACION(): string {
        return 'api/v1/GestionAfiliado/ConsultarProductos/';
    },
    GESTIONAFILIADOS_CONSULTAR_PRODUCTO_CONFIGURACION_COMPLETOS(): string {
        return 'api/v1/GestionAfiliado/ConsultarProductosCompletos/';
    },
    GESTIONAFILIADOS_CONSULTAR_PRODUCTO_EDADES_CONFIGURACION(): string {
        return 'api/v1/GestionAfiliado/ConsultarProductosEdades/';
    },
    GESTIONAFILIADOS_CONSULTAR_PRODUCTO_ESTADOS_CONFIGURACION(): string {
        return 'api/v1/GestionAfiliado/ConsultarEstados/';
    },
    GESTIONAFILIADOS_CONSULTAR_PRODUCTO_PARENTESCOS_CONFIGURACION(): string {
        return 'api/v1/GestionAfiliado/ConsultarParentescos/';
    },
    GESTIONAFILIADOS_CONSULTAR_EDICION_ID(): string {
        return 'api/v1/GestionAfiliado/ConsultarEdicion/';
    },
    GESTIONAFILIADOS_CONSULTAR_EDICION_BENEFICIARIO_ID(): string {
        return 'api/v1/GestionAfiliado/ConsultarEdicionBeneficiario/';
    },
    GESTIONAFILIADOS_CONSULTAR_MARCAS(): string {
        return 'api/v1/GestionAfiliado/ConsultarMarcas/';
    },
    GESTIONAFILIADOS_CONSULTAR_MARCAS_REFERENCIAS(): string {
        return 'api/v1/GestionAfiliado/ConsultarMarcasReferencias/';
    },
    GESTIONAFILIADOS_CONSULTAR_DOCUMENTOS(): string {
        return 'api/v1/GestionAfiliado/ConsultarEdicionDocumentos/';
    },
    GESTIONAFILIADOS_DESCARGAR_DOCUMENTOS(): string {
        return 'api/v1/GestionAfiliado/DescargarDocumentos/';
    },
    GESTIONAFILIADOS_ELIMINAR_AFILIACION(): string {
        return 'api/v1/GestionAfiliado/EliminarAfiliacion/';
    },
    LISTAS_PRODUCTOSPLAZOS(): string {
        return 'PRODUCTOSPLAZOS';
    },
    CONFIGURACIONLOCAL_USUARIO(): string {
        return './assets/archivoslocales/verificarusuario.txt';
    },
    CONFIGURACIONLOCAL_MENU(): string {
        return './assets/archivoslocales/menuusuario.txt';
    },
    CONFIGURACIONLOCAL_PRODUCTOS(): string {
        return './assets/archivoslocales/productos.txt';
    },
    CONFIGURACIONLOCAL_GESTIONAFILIADO(): string {
        return './assets/archivoslocales/gestionafiliado.txt';
    },
    CONFIGURACIONLOCAL_CONFIGURACIONLISTAS(): string {
        return './assets/archivoslocales/configuracionlistas.txt';
    },
    CONFIGURACIONLOCAL_RESUMEN(): string {
        return './assets/archivoslocales/resumen.txt';
    },
    STORAGE_DATOS(): string {
        return 'DATOSUSUARIOSTORAGE';
    },
    MAESTROS_SECTORES_CONSULTAR(): string {
        return 'api/v1/Sectores/Consultar/';
    },
    MAESTROS_SECTORES_ACTUALIZAR(): string {
        return 'api/v1/Sectores/Actualizar/';
    },
    MAESTROS_SECTORES_ELIMINAR(): string {
        return 'api/v1/Sectores/Eliminar/';
    },
    MAESTROS_ROLESDOMINIO_CONSULTAR(): string {
        return 'api/v1/RolesDominio/Consultar/';
    },
    MAESTROS_ROLESDOMINIO_ACTUALIZAR(): string {
        return 'api/v1/RolesDominio/Actualizar/';
    },
    MAESTROS_ROLESDOMINIO_ELIMINAR(): string {
        return 'api/v1/RolesDominio/Eliminar/';
    },
    MAESTROS_ALIADOSCANALES_CONSULTAR(): string {
        return 'api/v1/AliadosCanales/Consultar/';
    },
    MAESTROS_ALIADOSCANALES_ACTUALIZAR(): string {
        return 'api/v1/AliadosCanales/Actualizar/';
    },
    MAESTROS_ALIADOSCANALES_ELIMINAR(): string {
        return 'api/v1/AliadosCanales/Eliminar/';
    },
    MAESTROS_ALIADOSNOTIFICACIONES_CONSULTAR(): string {
        return 'api/v1/AliadosNotificaciones/Consultar/';
    },
    MAESTROS_ALIADOSNOTIFICACIONES_ACTUALIZAR(): string {
        return 'api/v1/AliadosNotificaciones/Actualizar/';
    },
    MAESTROS_ALIADOSNOTIFICACIONES_ELIMINAR(): string {
        return 'api/v1/AliadosNotificaciones/Eliminar/';
    },
    MAESTROS_ALIADOS_CONSULTAR(): string {
        return 'api/v1/Aliados/Consultar/';
    },
    MAESTROS_ALIADOS_ACTUALIZAR(): string {
        return 'api/v1/Aliados/Actualizar/';
    },
    MAESTROS_ALIADOS_ELIMINAR(): string {
        return 'api/v1/Aliados/Eliminar/';
    },
    MAESTROS_PRODUCTOS_CONSULTAR(): string {
        return 'api/v1/MaestroProductos/Consultar/';
    },
    MAESTROS_PRODUCTOS_PLAZOS_CONSULTAR(): string {
        return 'api/v1/MaestroProductos/ProductosPlazos_Consultar/';
    },
    MAESTROS_PRODUCTOS_EDADES_CONSULTAR(): string {
        return 'api/v1/MaestroProductos/ProductosEdades_Consultar/';
    },
    MAESTROS_PRODUCTOS_CAMPOS_CONSULTAR(): string {
        return 'api/v1/MaestroProductos/ProductosCampos_Consultar/';
    },
    MAESTROS_PRODUCTOS_CAMPOSBENEFICIARIOS_CONSULTAR(): string {
        return 'api/v1/MaestroProductos/ProductosCamposBeneficiarios_Consultar/';
    },
    MAESTROS_PRODUCTOS_NOTIFICACIONES_CONSULTAR(): string {
        return 'api/v1/MaestroProductos/ProductosNotificaciones_Consultar/';
    },
    MAESTROS_PRODUCTOS_EXPEDIENTES_CONSULTAR(): string {
        return 'api/v1/MaestroProductos/ProductosExpedientes_Consultar/';
    },
    MAESTROS_PRODUCTOS_ESTADOSDIAS_CONSULTAR(): string {
        return 'api/v1/MaestroProductos/ProductosEstadosDias_Consultar/';
    },
    MAESTROS_PRODUCTOS_FIRMAELECTRONICA_CONSULTAR(): string {
        return 'api/v1/MaestroProductos/ProductosFirmaElectronica_Consultar/';
    },
    MAESTROS_PRODUCTOS_CODIGOSACTIVACION_CONSULTAR(): string {
        return 'api/v1/MaestroProductos/ProductosCodigosActivacion_Consultar/';
    },
    MAESTROS_PRODUCTOS_CODIGOSACTIVACION_CARGAR(): string {
        return 'api/v1/MaestroProductos/CargarCodigosActivos';
    },
    MAESTROS_PRODUCTOS_SUBIRARCHIVOFIRMAELECTRONICA(): string {
        return 'api/v1/MaestroProductos/SubirArchivoFirmaElectronica';
    },
    MAESTROS_PRODUCTOS_DESCARGARARCHIVOFIRMAELECTRONICA(): string {
        return 'api/v1/MaestroProductos/DescargarArchivosFirmaElectronica';
    },
    MAESTROS_PRODUCTOS_CONSULTAR_LISTAS(): string {
        return 'api/v1/MaestroProductos/ConsultarListas/';
    },
    MAESTROS_PRODUCTOS_CONSULTAR_ALIADOS(): string {
        return 'api/v1/MaestroProductos/ConsultarAliados/';
    },
    MAESTROS_PRODUCTOS_ACTUALIZAR(): string {
        return 'api/v1/MaestroProductos/Actualizar/';
    },
    FIRMA_ELECTRONICA_CONSULTARLISTAS(): string {
        return 'api/v1/FirmaElectronica/ConsultarListas/';
    },
    FIRMA_ELECTRONICA_CONSULTAR(): string {
        return 'api/v1/FirmaElectronica/Consultar/';
    },
    FIRMA_ELECTRONICA_CONSULTARPENDIENTES(): string {
        return 'api/v1/FirmaElectronica/ConsultarPendientes/';
    },
    FIRMA_ELECTRONICA_REFRESCARESTADO(): string {
        return 'api/v1/FirmaElectronica/RefrescarEstado/';
    },
    FIRMA_ELECTRONICA_ENVIARRECORDATORIO(): string {
        return 'api/v1/FirmaElectronica/EnviarRecordatorio/';
    },
    FIRMA_ELECTRONICA_GENERARCODIGO(): string {
        return 'api/v1/FirmaElectronica/GenerarCodigo/';
    },
    FIRMA_ELECTRONICA_ACTUALIZAR(): string {
        return 'api/v1/FirmaElectronica/Actualizar/';
    },
    FIRMA_ELECTRONICA_ELIMINAR(): string {
        return 'api/v1/FirmaElectronica/Eliminar/';
    },
    FIRMA_ELECTRONICA_DESCARGARDOCUMENTO(): string {
        return 'api/v1/FirmaElectronica/DescargarDocumento/';
    },
    EXPEDIENTES_CONSULTAR(): string {
        return 'api/v1/GestionExpedientes/Consultar/';
    },
    EXPEDIENTES_CONSULTARRESUMEN(): string {
        return 'api/v1/GestionExpedientes/ConsultarResumen/';
    },
    EXPEDIENTES_DETALLE_INFORMACIONGENERAL(): string {
        return 'api/v1/GestionExpedientes/ConsultarDetalle_InformacionGeneral/';
    },
    EXPEDIENTES_DETALLE_EXPEDIENTE(): string {
        return 'api/v1/GestionExpedientes/ConsultarDetalle_Expediente/';
    },
    EXPEDIENTES_DETALLE_VISTAGENERAL(): string {
        return 'api/v1/GestionExpedientes/ConsultarDetalle_VistaGeneral/';
    },
    EXPEDIENTES_GENERAR_SINCRONIZACION(): string {
        return 'api/v1/GestionExpedientes/Generar_Sincronizacion/';
    },
    EXPEDIENTES_DETALLE_ADJUNTO(): string {
        return 'api/v1/GestionExpedientes/DescargarAdjunto/';
    },
    OPERACIONES_REEMBOLSO_CONSULTARLISTAS(): string {
        return 'api/v1/OperacionesReembolso/ConsultarListas/';
    },
    OPERACIONES_REEMBOLSO_CONSULTAR(): string {
        return 'api/v1/OperacionesReembolso/Consultar/';
    },
    OPERACIONES_REEMBOLSO_ACTUALIZAR(): string {
        return 'api/v1/OperacionesReembolso/Actualizar/';
    },
    OPERACIONES_REEMBOLSO_ELIMINAR(): string {
        return 'api/v1/OperacionesReembolso/Eliminar/';
    },
    OPERACIONES_REEMBOLSO_ACTUALIZAR_ESTADO(): string {
        return 'api/v1/OperacionesReembolso/ActualizarEstado/';
    },
    MAESTROS_PAISES_CONSULTAR_DEFECTO(): string {
        return 'api/v1/Paises/ConsultarDefecto';
    },
    MAESTROS_CIUDADES_CONSULTAR(): string {
        return 'api/v1/Ciudades/Consultar/';
    },
    MAESTROS_CIUDADES_ACTUALIZAR(): string {
        return 'api/v1/Ciudades/Actualizar/';
    },
    MAESTROS_CIUDADES_ELIMINAR(): string {
        return 'api/v1/Ciudades/Eliminar/';
    },
    MAESTROS_DASHBOARD_CONSULTAR(): string {
        return 'api/v1/DashBoard/Consultar/';
    },
    MAESTROS_CIUDADES_CONSULTARCOBERTURA(): string {
        return 'api/v1/Ciudades/ConsultarColorCobertura/';
    },
    MAESTROS_CIUDADES_CONSULTARCOBERTURACODIGOMAPA(): string {
        return 'api/v1/Ciudades/ConsultarColorCoberturaCodigoMapa/';
    },
    MAESTROS_CIUDADES_CONSULTARPOLIGONO(): string {
        return 'api/v1/Ciudades/ConsultarPoligono/';
    },
    MAESTROS_DASHBOARD_ACTUALIZAR(): string {
        return 'api/v1/DashBoard/Actualizar/';
    },
    MAESTROS_DASHBOARD_ROLES_CONSULTAR(): string {
        return 'api/v1/DashBoard/Roles_Consultar/';
    },
    MAESTROS_DASHBOARD_ROLES_ACTUALIZAR(): string {
        return 'api/v1/DashBoard/Roles_Actualizar/';
    },
    MAESTROS_GRUPOS_CONSULTAR(): string {
        return 'api/v1/Grupos/Consultar/';
    },
    MAESTROS_GRUPOS_ACTUALIZAR(): string {
        return 'api/v1/Grupos/Actualizar/';
    },
    MAESTROS_GRUPOS_ELIMINAR(): string {
        return 'api/v1/Grupos/Eliminar/';
    },
    MAESTROS_GRUPOS_ROLES_CONSULTAR(): string {
        return 'api/v1/Grupos/Roles_Consultar/';
    },
    MAESTROS_GRUPOS_ROLES_ACTUALIZAR(): string {
        return 'api/v1/Grupos/Roles_Actualizar/';
    },
    MAESTROS_MENUS_ROLES_CONSULTAR(): string {
        return 'api/v1/Grupos/RolesMenu_Consultar';
    },
    MAESTROS_MENUS_ROLES_ACTUALIZAR(): string {
        return 'api/v1/Grupos/RolesMenu_Actualizar';
    },
    MAESTROS_GRUPOSMENUS_CONSULTAR(): string {
        return 'api/v1/GruposMenu/Consultar/';
    },
    MAESTROS_GRUPOSMENUS_ACTUALIZAR(): string {
        return 'api/v1/GruposMenu/Actualizar/';
    },
    MAESTROS_GRUPOSMENUS_ELIMINAR(): string {
        return 'api/v1/GruposMenu/Eliminar/';
    },
    MAESTROS_PROVINCIAS_CONSULTAR(): string {
        return 'api/v1/Provincias/Consultar/';
    },
    MAESTROS_PROVINCIAS_ACTUALIZAR(): string {
        return 'api/v1/Provincias/Actualizar/';
    },
    MAESTROS_PROVINCIAS_ELIMINAR(): string {
        return 'api/v1/Provincias/Eliminar/';
    },
    MAESTROS_ROLES_CONSULTAR(): string {
        return 'api/v1/Roles/Consultar/';
    },
    MAESTROS_ROLES_ACTUALIZAR(): string {
        return 'api/v1/Roles/Actualizar/';
    },
    MAESTROS_ROLES_ELIMINAR(): string {
        return 'api/v1/Roles/Eliminar/';
    },
    MAESTROS_USUARIOS_CONSULTAR(): string {
        return 'api/v1/Usuarios/Consultar/';
    },
    MAESTROS_USUARIOS_ACTUALIZAR(): string {
        return 'api/v1/Usuarios/Actualizar/';
    },
    MAESTROS_USUARIOS_ELIMINAR(): string {
        return 'api/v1/Usuarios/Eliminar/';
    },
    MAESTROS_USUARIOS_ROLES_CONSULTAR(): string {
        return 'api/v1/Usuarios/Roles_Consultar/';
    },
    MAESTROS_USUARIOS_ROLES_ACTUALIZAR(): string {
        return 'api/v1/Usuarios/Roles_Actualizar/';
    },
    MAESTROS_USUARIOS_ALIADOS_CANALES_CONSULTAR(): string {
        return 'api/v1/Usuarios/Aliados_Canales_Consultar/';
    },
    MAESTROS_USUARIOS_IPSAUTORIZADAS_CONSULTAR(): string {
        return 'api/v1/Usuarios/ConsultarIpsAutorizadas/';
    },
    GENERARCONSULTAS_CONSULTAR(): string {
        return 'api/v1/GenerarConsultas/Consultar/';
    },
    GENERARCONSULTAS_PARAMETROSCONSULTAR(): string {
        return 'api/v1/GenerarConsultas/Parametros_Consultar/';
    },
    GENERARCONSULTAS_EJECUTAR(): string {
        return 'api/v1/GenerarConsultas/Ejecutar/';
    },
    GENERARCONSULTAS_EXPORTARDIRECTO(): string {
        return 'api/v1/GenerarConsultas/ExportarDirecto/';
    },
    GENERARCONSULTAS_EXPORTARCONSULTA(): string {
        return 'api/v1/GenerarConsultas/ExportarConsulta/';
    },
    MAESTROS_CONSULTAS_CONSULTAR(): string {
        return 'api/v1/MaestroConsultas/Consultar/';
    },
    MAESTROS_CONSULTAS_ACTUALIZAR(): string {
        return 'api/v1/MaestroConsultas/Actualizar/';
    },
    MAESTROS_CONSULTAS_ELIMINAR(): string {
        return 'api/v1/MaestroConsultas/Eliminar/';
    },
    MAESTROS_CONSULTAS_APLICACIONES_CONSULTAR(): string {
        return 'api/v1/MaestroConsultas/Aplicaciones_Consultar/';
    },
    MAESTROS_CONSULTAS_APLICACIONES_ACTUALIZAR(): string {
        return 'api/v1/MaestroConsultas/Aplicaciones_Actualizar/';
    },
    MAESTROS_CONSULTAS_ROLES_CONSULTAR(): string {
        return 'api/v1/MaestroConsultas/Roles_Consultar/';
    },
    MAESTROS_CONSULTAS_ROLES_ACTUALIZAR(): string {
        return 'api/v1/MaestroConsultas/Roles_Actualizar/';
    },
    MAESTROS_CONSULTAS_USUARIOS_CONSULTAR(): string {
        return 'api/v1/MaestroConsultas/Usuarios_Consultar/';
    },
    MAESTROS_CONSULTAS_USUARIOS_ACTUALIZAR(): string {
        return 'api/v1/MaestroConsultas/Usuarios_Actualizar/';
    },
    MAESTROS_CONSULTAS_PARAMETROS_CONSULTAR(): string {
        return 'api/v1/MaestroConsultas/Parametros_Consultar/';
    },
    MAESTROS_CONSULTAS_PARAMETROS_ACTUALIZAR(): string {
        return 'api/v1/MaestroConsultas/Parametros_Actualizar/';
    },
    MAESTROS_CONSULTAS_PARAMETROS_ELIMINAR(): string {
        return 'api/v1/MaestroConsultas/Parametros_Eliminar/';
    },
    MAESTROS_CONSULTASTIPOS_CONSULTAR(): string {
        return 'api/v1/MaestroConsultasTipos/Consultar/';
    },
    MAESTROS_CONSULTASTIPOS_ACTUALIZAR(): string {
        return 'api/v1/MaestroConsultasTipos/Actualizar/';
    },
    MAESTROS_CONSULTASTIPOS_ELIMINAR(): string {
        return 'api/v1/MaestroConsultasTipos/Eliminar/';
    },
    MAESTROS_CONSULTASTIPOSPARAMETROS_CONSULTAR(): string {
        return 'api/v1/MaestroConsultasTiposParametros/Consultar/';
    },
    MAESTROS_CONSULTASTIPOSPARAMETROS_ACTUALIZAR(): string {
        return 'api/v1/MaestroConsultasTiposParametros/Actualizar/';
    },
    MAESTROS_CONSULTASTIPOSPARAMETROS_ELIMINAR(): string {
        return 'api/v1/MaestroConsultasTiposParametros/Eliminar/';
    },
    SUBIRARCHIVOS_USUARIO_CONSULTAR(): string {
        return 'api/v1/SubirArchivos/Consultar/';
    },
    SUBIRARCHIVOS_SUBDIRECTORIOS_DIRECTORIO_CONSULTAR(): string {
        return 'api/v1/SubirArchivos/ConsultarSubDirectorio/';
    },
    SUBIRARCHIVOS_USUARIO_CONSULTARARCHIVOS(): string {
        return 'api/v1/SubirArchivos/ConsultarArchivos/';
    },
    SUBIRARCHIVOS_USUARIO_ELIMINARARCHIVOS(): string {
        return 'api/v1/SubirArchivos/EliminarArchivos/';
    },
    SUBIRARCHIVOS_USUARIO_DESCARGARARCHIVOS(): string {
        return 'api/v1/SubirArchivos/DescargarArchivos/';
    },
    SUBIRARCHIVOS_USUARIO_CREARDIRECTORIO(): string {
        return 'api/v1/SubirArchivos/CrearDirectorio/';
    },
    SUBIRARCHIVOS_USUARIO_IMPORTARARCHIVOS(): string {
        return 'api/v1/SubirArchivos/ImportarArchivos/';
    },
    MAESTROS_CARGASARCHIVOS_CONSULTAR(): string {
        return 'api/v1/MaestroCargasArchivos/Consultar/';
    },
    MAESTROS_CARGASARCHIVOS_ACTUALIZAR(): string {
        return 'api/v1/MaestroCargasArchivos/Actualizar/';
    },
    MAESTROS_CARGASARCHIVOS_ELIMINAR(): string {
        return 'api/v1/MaestroCargasArchivos/Eliminar/';
    },
    MAESTROS_CARGASARCHIVOS_ROLES_CONSULTAR(): string {
        return 'api/v1/MaestroCargasArchivos/Roles_Consultar/';
    },
    MAESTROS_CARGASARCHIVOS_USUARIOS_CONSULTAR(): string {
        return 'api/v1/MaestroCargasArchivos/Usuarios_Consultar/';
    },
    MAESTROS_CARGASARCHIVOS_CARGARECURRENTEARCHIVOS_CONSULTAR(): string {
        return 'api/v1/MaestroCargasArchivos/CargaRecurrenteArchivos_Consultar/';
    },
    MAESTROS_CARGAAPICLIENTESASEGURADOS_CONSULTAR(): string {
        return 'api/v1/MaestroCargaApiClientesAsegurados/Consultar/';
    },
    MAESTROS_CARGAAPICLIENTESASEGURADOS_ACTUALIZAR(): string {
        return 'api/v1/MaestroCargaApiClientesAsegurados/Actualizar/';
    },
    MAESTROS_CARGAAPICLIENTESASEGURADOS_ELIMINAR(): string {
        return 'api/v1/MaestroCargaApiClientesAsegurados/Eliminar/';
    },
    MAESTROS_CARGASARCHIVOS_CARGARECURRENTEARCHIVOS_MIGRARDATOS(): string {
        return 'api/v1/MaestroCargasArchivos/MigrarDatos/';
    },
    MAESTROS_CARGASARCHIVOS_CARGARECURRENTEARCHIVOS_CONSULTARCANALES(): string {
        return 'api/v1/MaestroCargasArchivos/ConsultarCanales/';
    },
    MAESTROS_CARGASARCHIVOS_CARGARECURRENTEARCHIVOS_CONSULTARPRODUCTOS(): string {
        return 'api/v1/MaestroCargasArchivos/ConsultarProductos/';
    },
    RECAUDOS_CONSULTARALIADOS(): string {
        return 'api/v1/Recaudo/ConsultarAliados';
    },
    RECAUDOS_CONSULTARPROGRAMA(): string {
        return 'api/v1/Recaudo/ConsultarPrograma/';
    },
    RECAUDOS_CONSULTARRECAUDO_PENDIENTES(): string {
        return 'api/v1/Recaudo/ConsultarRecaudosPendientes/';
    },
    RECAUDOS_CONSULTARRECAUDO(): string {
        return 'api/v1/Recaudo/ConsultarRecaudos/';
    },
    RECAUDOS_GENERAR(): string {
        return 'api/v1/Recaudo/GenerarRecaudos';
    },
    RECAUDOS_MARCARCOMPLETO(): string {
        return 'api/v1/Recaudo/MarcarRecaudoCompleto';
    },
    RECAUDOS_ANULAR(): string {
        return 'api/v1/Recaudo/AnularRecaudos';
    },
    RECAUDOS_RESPUESTA(): string {
        return 'api/v1/Recaudo/RespuestaRecaudos/';
    },
    RECAUDOS_DESCARGARARCHIVOGENERADO(): string {
        return 'api/v1/Recaudo/DescargarArchivoGeneradoRecaudos';
    },
    RECAUDOS_DESCARGARRESPUESTA(): string {
        return 'api/v1/Recaudo/DescargarArchivoRespuestaRecaudos';
    },
    PROSPECTOSCARGA_CONSULTARALIADOS(): string {
        return 'api/v1/ProspectosCarga/ConsultarAliados';
    },
    PROSPECTOSCARGA_CONSULTAR(): string {
        return 'api/v1/ProspectosCarga/Consultar';
    },
    PROSPECTOSCARGA_ANULAR(): string {
        return 'api/v1/ProspectosCarga/Anular';
    },
    PROSPECTOSCARGA_PROCESAR(): string {
        return 'api/v1/ProspectosCarga/Procesar';
    },
    PROSPECTOSCARGA_DESCARGARARCHIVO(): string {
        return 'api/v1/ProspectosCarga/DescargarArchivoImportado';
    },
    ESTADO_ACTIVO(): string {
        return 'ACTIVO';
    },
    ESTADO_INACTIVO(): string {
        return 'INACTIVO';
    },
    ESTADO_BLOQUEADO(): string {
        return 'BLOQUEADO';
    },
    MAESTROS_ALIADOSPORCENTAJEBENEFICIARIOS_CONSULTAR(): string {
        return 'api/v1/AliadosPorcentajesBeneficiarios/Consultar/';
    },
    MAESTROS_PARAMETROS_CONSULTAR(): string {
        return 'api/v1/MaestroParametros/Consultar/';
    },
    MAESTROS_MARCAS_CONSULTAR(): string {
        return 'api/v1/MaestroMarcas/Consultar/';
    },
    MAESTROS_MARCAS_ACTUALIZAR(): string {
        return 'api/v1/MaestroMarcas/Actualizar/';
    },
    MAESTROS_MARCAS_ELIMINAR(): string {
        return 'api/v1/MaestroMarcas/Eliminar/';
    },
    MAESTROS_MARCAS_REFERENCIAS_CONSULTAR(): string {
        return 'api/v1/MaestroMarcas/ConsultarReferencias/';
    },
    MAESTROS_CONFIGURACIONCOMERCIALIZACION_CONSULTAR(): string {
        return 'api/v1/MaestroConfiguracionComercializacion/Consultar/';
    },
    MAESTROS_CONFIGURACIONCOMERCIALIZACION_ACTUALIZAR(): string {
        return 'api/v1/MaestroConfiguracionComercializacion/Actualizar/';
    },
    MAESTROS_CONFIGURACIONCOMERCIALIZACION_ELIMINAR(): string {
        return 'api/v1/MaestroConfiguracionComercializacion/Eliminar/';
    },
    MAESTROS_CONFIGURACIONCOMERCIALIZACION_DETALLES_CONSULTAR(): string {
        return 'api/v1/MaestroConfiguracionComercializacion/ConsultarDetalles/';
    },
    MAESTROS_CONFIGURACIONCOMERCIALIZACION_CODIGOCOMERCIALIZACION_CONSULTAR(): string {
        return 'api/v1/MaestroConfiguracionComercializacion/ConsultarConfiguracionCodigo/';
    },
}